import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthorizeService } from '../authorize.service';
import { ConfigService } from '../config.service';

@Injectable({
  providedIn: 'root',
})
export class JwtInterceptor implements HttpInterceptor {
  private readonly authorize = inject(AuthorizeService);
  private readonly configService = inject(ConfigService);

  urlPropertyNames = ['clubHubApiUrl', 'identityServerUrl'];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authorize.getAccessToken().pipe(mergeMap((token) => this.processRequestWithToken(token, req, next)));
  }

  // Checks if there is an access_token available in the authorize service
  // and adds it to the request in case it's targeted at the same origin as the
  // single page application.
  private processRequestWithToken(token: string, req: HttpRequest<any>, next: HttpHandler) {
    if (!!token && this.isSameOriginUrl(req)) {
      req = req.clone({
        setHeaders: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          Authorization: `Bearer ${token}`,
        },
      });
    }

    return next.handle(req);
  }

  private isSameOriginUrl(req: any) {
    return this.urlPropertyNames.some((property) => this.checkUrlAgainstProperty(property, req.url));
  }

  private checkUrlAgainstProperty(property: string, url: string): boolean {
    return this.configService.config.hasOwnProperty(property) && url.startsWith(`${(<any> this.configService.config)[property]}/`);
  }
}
